// Others
import axiosClient from './axiosClient';
import {
  IBodyUpdateSchedule,
  IFormSchedule,
  IQueryParamSchedulesDashboard,
  IScheduleDashboard,
  IScheduleDetail,
} from '~/utils/interface/schedule';
import { urlApiSchedule } from '~/utils/constants/apis';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IParamSchedule, ISchedule, IScheduleTimeLine } from '~/utils/interface/schedule';

const scheduleApi = {
  createSchedule(formData: IFormSchedule) {
    const url = urlApiSchedule.createSchedule;
    return axiosClient.post<IBaseResponse>(url, formData);
  },

  getScheduleList(params: IParamSchedule) {
    const url = urlApiSchedule.getScheduleList;
    return axiosClient.get<IBaseResponse<ISchedule[] | IScheduleTimeLine[]>>(url, {
      params,
    });
  },

  getScheduleDashboardList(params: IQueryParamSchedulesDashboard) {
    const url = urlApiSchedule.getScheduleDashboardList;
    return axiosClient.get<IBaseResponse<IListDataResponse<IScheduleDashboard[]>>>(url, {
      params,
    });
  },

  deleteSchedule(idSchedule: string) {
    const url = urlApiSchedule.deleteSchedule(idSchedule);
    return axiosClient.delete<IBaseResponse>(url);
  },

  getScheduleDetail: (scheduleId: string) => {
    const url = urlApiSchedule.getScheduleDetail(scheduleId);
    return axiosClient.get<IBaseResponse<IScheduleDetail>>(url);
  },

  updateSchedule({ scheduleId, body }: IBodyUpdateSchedule) {
    const url = urlApiSchedule.updateSchedule(scheduleId);
    return axiosClient.put<IBaseResponse>(url, body);
  },
};

export default scheduleApi;
